import React, {useEffect, useState, Suspense, lazy} from "react";
import {Switch, Route} from "react-router-dom";
import {useHistory} from "react-router-dom";
import GuService from "./services/GuService";
import Base from "./base.js";
import {trackPromise} from "react-promise-tracker";
import DommusLoading from './components/DommusLoading/DommusLoading';
import Integracoes from "./pages/Integracoes";
import Swal from "sweetalert2";

export default function Routes({}) {
    const [tokenValido, setTokenValido] = useState(false);
    const telas = GuService.getLocalState("telas");
    const history = useHistory();
    const Evento = lazy(() => import('./pages/Evento'));
    const Aprovacao = lazy(() => import('./pages/Aprovacao'));
    const Chamados = lazy(() => import('./pages/Widgets/MeusChamados/chamados'));
    const Inscricoes = lazy(() => import('./pages/Inscricoes'));
    const CriarLista = lazy(() => import('./pages/CriarLista'));
    const Departamentos = lazy(() => import('./pages/Departamentos'));
    const Usuarios = lazy(() => import('./pages/Perfil'));
    const Motivos = lazy(() => import('./pages/Motivos'));
    const CriarTipoTarefa = lazy(() => import('./pages/TiposTarefa'));
    const AgendamentoVisita = lazy(() => import('./pages/AgendamentoVisita'));
    const TiposTicket = lazy(() => import('./pages/TiposTicket'));
    const Templates = lazy(() => import('./pages/Templates'));
    const RelatoriosDiversos = lazy(() => import('./pages/Relatorios/Diversos'));
    const Indicacoes = lazy(() => import('./pages/Indicacoes'));
    const SolicitacaoCriacaoAtualizacao = lazy(() => import('./pages/SolicitacaoCriacaoAtualizacao'));
    const Login = lazy(() => import('./pages/Login'));
    const Logout = lazy(() => import('./pages/Logout'));
    const GuLogin = lazy(() => import('./pages/Auth/GuLogin'));
    const Auth = lazy(() => import('./pages/Auth'));
    const Questionarios= lazy(() => import('./pages/Questionarios'));
    const Dashboards = lazy(() => import('./pages/Dashboards/index.tsx'));
    const BuscarConfiguracao = lazy(() => import('./pages/Auth/BuscarConfiguracao'));
    const FluxoEtapas = lazy(() => import('./pages/FluxoEtapas/index.tsx'));
    const FaqPortalCliente = lazy(() => import('./pages/FaqPortalCliente'));
    const Automacoes = lazy(() => import('./pages/Automacoes/index.tsx'));
    const TicketEtapas = lazy(() => import('./pages/TicketEtapas/index.tsx'));
    const TicketTipoMotivo = lazy(() => import('./pages/MotivoConclusao/index.tsx'));
    const MotivoRetrocessoEtapa = lazy(() => import('./pages/MotivoRetrocessoEtapa/index.tsx'));
    const MotivoCancelamentoTicket = lazy(() => import('./pages/MotivoCancelamentoTicket/index.tsx'));
    const CamposDinamicosPage = lazy(() => import('./pages/CamposDinamicos/index.tsx'));
    const ArquitetosPage = lazy(() => import('./pages/ArquitetosPage/index.tsx'));
    const TicketCategoriaPage = lazy(() => import('./pages/TicketCategoriaPage/index.tsx'));
    const Patologias = lazy(() => import('./pages/Patologias/index.tsx'));
    const Conteudos = lazy(() => import('./pages/Conteudos/index.tsx'));

    useEffect(() => {
        if (!history.location.pathname.includes("gu-login")) {
            trackPromise(valida());
        }
    }, [history.location.pathname]);


    async function valida() {
        let tokenAtual = GuService.getLocalState("token");
        if (
            GuService.getLocalState("token") != null &&
            GuService.getLocalState("idUsuario") != null
        ) {
            GuService.validaToken(tokenAtual)
                .then((res) => {
                    GuService.setLocalState("permissoes", res.data.permissoes);
                    setTokenValido(res.data.valido);
                })
                .catch((err) => {
                  if(err.response.status == 401) {
                    Swal.fire({
                      titleText: "Ooops...",
                      text: err.response.data.validacaoModeloHorario.mensagem,
                      icon: 'error'
                    }).then(value => {
                      if(value.isConfirmed) {
                        GuService.redirectGU();
                      }
                    });
                  } else {
                    GuService.redirectGU();
                  }
                });
        } else {
            GuService.redirectGU();
        }
    }

    return (
        <Switch>
         <Suspense fallback={<DommusLoading />}>

            <Route path="/login" exact component={() => <Login />}/>
            <Route path="/sair" exact component={() => <Logout />}/>
            <Route path="/gu-login/:token"  component={() => <GuLogin />}/>
            <Route path="/buscar-configuracao" exact component={() => <BuscarConfiguracao />}/>

            <Route path="/auth" exact component={() => <Auth />}/>
            {tokenValido && (
                <Base
                    history={history}
                    conteudo={
                        <div className="content-body">
                            {telas.includes("portal_cliente_atendente") && (
                                <>
                                    <Route path="/" exact component={() => <Chamados />}/>
                                    <Route path="/eventos" exact component={() => <Evento />}/>
                                    <Route path="/aprovacao" exact component={() => <Aprovacao />}/>
                                    <Route path="/solicitacao-novo-acesso" component={() => <SolicitacaoCriacaoAtualizacao />}/>
                                    <Route path="/inscricoes" exact component={() => <Inscricoes />}/>
                                    <Route path="/criar" exact component={() => <CriarLista />}/>
                                    <Route path="/fila/:idFila" exact component={() => <Chamados/>}/>
                                    <Route path="/agenda-do-usuario" exact component={() => <AgendamentoVisita />}/>
                                    <Route path="/indicacoes" exact component={() => <Indicacoes />}/>
                                    <Route path="/relatorios/diversos" exact component={() => <RelatoriosDiversos/>}/>                                    
                                    <Route path="/motivos" exact component={() => <Motivos />}/>
                                    <Route path="/fluxo-etapas" exact component={() => <FluxoEtapas/>}/>
                                    <Route path="/etapas" exact component={() => <TicketEtapas/>}/>
                                    <Route path="/fluxo-atendimento" exact component={() => <TiposTicket />}/>
                                    <Route path="/motivo-retrocesso-etapa" exact component={() => <MotivoRetrocessoEtapa />}/>
                                    <Route path="/motivo-cancelamento-ticket" exact component={() => <MotivoCancelamentoTicket />}/>
                                    <Route path="/automacoes" exact component={() => <Automacoes/>}/>
                                    <Route path="/campos-dinamicos" exact component={() => <CamposDinamicosPage/>}/>
                                    <Route path="/tipo-motivo" exact component={() => <TicketTipoMotivo/>}/>
                                    <Route path="/ticket-categoria" exact component={() => <TicketCategoriaPage/>}/>
                                    <Route path="/questionarios" exact component={() => <Questionarios />}/>
                                    <Route path="/faq-portal-cliente" exact component={() => <FaqPortalCliente/>}/>
                                    <Route path="/conteudos" exact component={() => <Conteudos/>}/>
                                    <Route path="/patologias" exact component={() => <Patologias/>}/>
                                </>
                            )}
                            {telas.includes("configuracoes_gestor") && (
                                <>
                                    <Route path="/usuarios" exact component={() => <Usuarios />}/>
                                    <Route path="/tipos-tarefa" exact component={() => <CriarTipoTarefa />}/>
                                    <Route path="/departamentos" exact component={() => <Departamentos />}/>
                                    <Route path="/templates" exact component={() => <Templates />}/>
                                    <Route path="/integracoes" exact component={() => <Integracoes/>}/>
                                    <Route path="/arquitetos" exact component={() => <ArquitetosPage/>}/>
                                </>
                            )}
                            {telas.includes('dashboards') && <Route path="/dashboards" exact component={() => <Dashboards />}/>}
                        </div>
                    }
                ></Base>
            )}
          </Suspense>
        </Switch>
    );
}
